import { useAutoAnimate } from '@formkit/auto-animate/react';
import { type ComponentPropsWithRef, useMemo } from 'react';

import { clsx } from '~/styles/utils';
import { mergeRefs } from '~/utils/mergeRefs';

import { fieldFooterStyle } from './FieldFooter.css';

type Props = ComponentPropsWithRef<'div'>;

export const FieldFooter = ({ children, ...delegated }: Props) => {
  const [ref] = useAutoAnimate();
  const mergedRef = useMemo(() => mergeRefs(ref, delegated.ref), [ref, delegated.ref]);

  const hasChildren = Array.isArray(children) ? children.some((child) => !!child) : !!children;

  if (!hasChildren) return null;

  return (
    <div {...delegated} className={clsx(fieldFooterStyle, delegated.className)} ref={mergedRef}>
      {children}
    </div>
  );
};
